/**
 * Chi vede gli importi, e come si valorizza la manutenzione fatta in casa.
 *
 * Una regola sola per tutta l'app: costi di manutenzione, prezzi di listino e
 * valori di magazzino li vedono direzione, amministrazione e tecnici. Preposti
 * e magazziniere usano le stesse pagine ma senza le cifre — a loro serve sapere
 * cosa è stato fatto e cosa c'è in giacenza, non quanto è costato.
 *
 * Qui si decide solo cosa disegnare: gli importi vengono tolti dal server prima
 * di arrivare, perché nascondere un numero a schermo non lo nasconde a chi apre
 * gli strumenti del browser. Vedi RUOLI_CON_I_COSTI in backend/server.py.
 */
export const RUOLI_CON_I_COSTI = ["admin", "amministrativo", "tecnico"];

export const vedeICosti = (user) => RUOLI_CON_I_COSTI.includes(user?.role);

/** "€ 1.234,50" — e un trattino quando l'importo non c'è o non spetta. */
export const euro = (n) =>
  n === null || n === undefined || n === ""
    ? "—"
    : `€ ${Number(n).toLocaleString("it-IT", { minimumFractionDigits: 2,
                                               maximumFractionDigits: 2 })}`;

/**
 * L'intervento fatto in casa non ha una fattura: si dichiara il tempo, e il
 * costo lo calcola il server sulla tariffa oraria. Qui servono solo le fasce da
 * proporre, a scatti di mezz'ora: sotto la mezz'ora non si scende, perché
 * misurare i minuti su un intervento in officina è una precisione finta.
 * L'ultima parola resta del server, che rifiuta quello che non torna.
 */
export const PASSO_MINUTI = 30;
export const MASSIMO_MINUTI = 60 * 12;

export const FASCE_MINUTI = Array.from(
  { length: MASSIMO_MINUTI / PASSO_MINUTI },
  (_, i) => (i + 1) * PASSO_MINUTI);

export const durataLeggibile = (minuti) => {
  const m = Number(minuti) || 0;
  const ore = Math.floor(m / 60);
  const resto = m % 60;
  if (!ore) return `${resto} min`;
  return resto ? `${ore} h ${resto} min` : `${ore} h`;
};

/**
 * Ogni quanto si ripete un controllo o una manutenzione.
 *
 * Sono le quattro cadenze che si usano in azienda. Se nessuna va bene si
 * mette la data a mano — ed è il caso normale su quello che impone un
 * fornitore, dove la scadenza la decide lui: la revisione di un autocarro,
 * la taratura di uno strumento.
 */
export const CADENZE = [
  { mesi: 3, etichetta: "Trimestrale" },
  { mesi: 4, etichetta: "Quadrimestrale" },
  { mesi: 6, etichetta: "Semestrale" },
  { mesi: 12, etichetta: "Annuale" },
];

/** La data che viene tanti mesi dopo quella data, in formato ISO. */
export const fraMesi = (dataIso, mesi) => {
  if (!dataIso || !mesi) return "";
  const [a, m, g] = dataIso.substring(0, 10).split("-").map(Number);
  const arrivo = new Date(a, m - 1 + mesi, 1);
  // Il 31 gennaio più un mese non fa il 31 febbraio: fa l'ultimo di febbraio.
  const ultimo = new Date(arrivo.getFullYear(), arrivo.getMonth() + 1, 0).getDate();
  arrivo.setDate(Math.min(g, ultimo));
  const p = (n) => String(n).padStart(2, "0");
  return `${arrivo.getFullYear()}-${p(arrivo.getMonth() + 1)}-${p(arrivo.getDate())}`;
};
